import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CopyTextToClipboardModule } from '../copy-text-to-clipboard/copy-text-to-clipboard.module';
import { GenesysEmailViewerComponent } from './genesys-email-viewer.component';
import { GenesysEmailAttachmentsModule } from 'shared/components/genesys-email-attachments/genesys-email-attachments.module';
import { EmailBodyPipe } from './pipes/email-body.pipe';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';
import { GenesysSecureFrameModule } from 'shared/components/genesys-secure-frame/genesys-secure-frame.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    CopyTextToClipboardModule,
    GenesysSecureFrameModule,
    GenesysEmailAttachmentsModule,
    CustomPipesModule
  ],
  declarations: [GenesysEmailViewerComponent, EmailBodyPipe],
  exports: [GenesysEmailViewerComponent]
})
export class GenesysEmailViewerModule {}
